import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const DescriptionLoaderWrapper = styled.div`
  min-width: 600px;
`;

export const RankLoaderWrapper = styled.div`
  width: 50px;
`;

export const LogoLoaderWrapper = styled.div`
  width: 32px;
`;

export const ThemeNameLoaderWrapper = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};
`;
